import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function setSelectedEnrollment(id: number) {
  return restApiClient.url(constructApiUrl(API.selectedEnrollment.set.url, { id })).post()
}
